import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ShowLinkedDocsComponent } from '../show-linked-docs/show-linked-docs.component';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { SearchDocumentInfoCriteria } from '../../models/SearchDocumentInfoCriteria';
import { Constants } from 'src/app/shared/model/Constants';
import { tap } from 'rxjs';
import { DocumentService } from '../../service/document.service';

@Component({
  selector: 'app-attachments-button',
  templateUrl: './attachments-button.component.html',
  styleUrls: ['./attachments-button.component.scss']
})
export class AttachmentsButtonComponent implements OnInit {

    constructor(
      public customDialogService: CustomDialogService,
      public documentService: DocumentService
    ) {
    }

  @Input() public referenceId: number;
  @Input() public referenceType: ReferenceType;
  @Input() public documentTypeId: number;
  @Input() public uploadDocumentsDescription = '';

  searchDocumentInfoCriteria: SearchDocumentInfoCriteria;
  isLoading: boolean;
  docCount: number;

  @ViewChild("attachmentsDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit(): void {
    this.initForm();
    this.loadDocuments();
  }

  initForm(): void {

    this.searchDocumentInfoCriteria = {
      referenceType: this.referenceType,
      referenceId: this.referenceId?.toString(),
      documentKindId: null,
      documentTypeIds: [this.documentTypeId],
      pageNumber: 1,
      rowsPerPage: Constants.MaxInt,
      sortDirection: ''
    }
  }

  loadDocuments() {
    this.isLoading = true;
    this.documentService.searchDocumentInfo(this.searchDocumentInfoCriteria).pipe(
      tap(() => { this.isLoading = false; }))
      .subscribe({
        next: (r) => this.docCount = r.length,
      });
  }

  showAttachments(){
    const dialogSettings: CustomDialogSettings = {
      content: ShowLinkedDocsComponent,
      maxWidth: '90vw',
      maxHeight: '90vh',
      minWidth: '30vw',
      minHeight: '30vh',
      appendTo: this.containerRef,
      dialogInputs: {
        referenceId : this.referenceId,
        referenceType: this.referenceType,
        documentTypeId: this.documentTypeId,
        uploadDocumentsDescription: this.uploadDocumentsDescription
      },
      resultCallback: (r: DialogResult) => {
          this.loadDocuments();
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  

}
